// extracted by mini-css-extract-plugin
export default {"CTA":"CTASection_CTA__fFOLV"};